// import React from "react";
//
// type MyProps = {
//   minute: number;
//   second: number;
//   onHandleCaptcha?: any
//   onHandleDisableCaptcha?: any;
//   onHandleEmptyCaptchaTag?: any;
//   onHandleSetShowTimer?:any;
// };
// type MyState = {
//   minutes: number;
//   seconds: number
// };
//
//
// class TimeCounter extends React.Component<MyProps, MyState> {
//
//   state: MyState = {
//     minutes: this.props.minute,
//     seconds: this.props.second,
//   };
//
//   private myInterval: any;
//
//   componentDidMount() {
//     this.myInterval = setInterval(() => {
//       const {seconds, minutes} = this.state
//
//       if (seconds > 0) {
//         this.setState(({seconds}) => ({
//           seconds: seconds - 1
//         }))
//       }
//       if (seconds === 0) {
//         if (minutes === 0) {
//           clearInterval(this.myInterval);
//           this.props.onHandleSetShowTimer(false);
//           this.props.onHandleDisableCaptcha(false);
//           this.props.onHandleEmptyCaptchaTag();
//           this.props.onHandleCaptcha();
//         } else {
//           this.setState(({minutes}) => ({
//             minutes: minutes - 1,
//             seconds: 59
//           }))
//         }
//       }
//     }, 1000)
//
//
//   }
//
//   componentWillUnmount() {
//     clearInterval(this.myInterval)
//   }
//
//   render() {
//     const {minutes, seconds} = this.state
//     return (
//       <div className="time-counter">
//         {minutes === 0 && seconds === 0 ? 'ارسال کد فعال سازی' : <span
//           className="time-counter__items">{minutes} : {seconds < 10 ? `0${seconds}` : seconds}</span>
//         }
//       </div>
//     )
//   }
// }
//
// export default TimeCounter;

import React from "react";

type MyProps = {
  onHandleCaptcha?: any
  onHandleDisableCaptcha?: any;
  onHandleEmptyCaptchaTag?: any;
  onHandleSetShowTimer?: any;
  setResendText?: any;
  setOtp?: any;
  setShowActivationCodeBox?: any;
};
type MyState = {
  minutes: number;
  seconds: number
};


class TimeCounter extends React.Component<MyProps, MyState> {

  state: MyState = {
    minutes: 2,
    seconds: 0,
  };

  private myInterval: any;

  componentDidMount() {
    this.myInterval = setInterval(() => {
      const {seconds, minutes} = this.state

      if (seconds > 0) {
        this.setState(({seconds}) => ({
          seconds: seconds - 1
        }))
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
          this.props.onHandleSetShowTimer(false);
          this.props.onHandleDisableCaptcha(false);
          this.props.setResendText(true);
          this.props.setShowActivationCodeBox(false);
          this.props.setOtp('');
          this.props.onHandleEmptyCaptchaTag();
          this.props.onHandleCaptcha();
        } else {
          this.setState(({minutes}) => ({
            minutes: minutes - 1,
            seconds: 59
          }))
        }
      }
    }, 1000)


  }

  componentWillUnmount() {
    clearInterval(this.myInterval)
  }

  render() {
    const {minutes, seconds} = this.state
    return (
      <div className="time-counter">
        {minutes === 0 && seconds === 0 ? null : <span
          className="time-counter__items">{minutes} : {seconds < 10 ? `0${seconds}` : seconds}</span>
        }
      </div>
    )
  }
}

export default TimeCounter;